module.exports = __webpack_public_path__ + "static/media/sundorbon.226e789e.png";